import { Component, OnInit } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';

import { Locale } from './../../service/locale.service';
import { Status } from './../../service/status.service';
import { AccountService } from './../../service/accountService.service';
import { LabelFormatService } from './../../service/labelFormatService.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent extends Module {

  private tilesDisplayable = true;

  constructor(private locale: Locale,
              private status: Status,
              private accountService: AccountService,
              private labelFormatService: LabelFormatService) {
    super();
    this.setBindExposer(this.status.getExposer());
  }

  public getTilesDisplayable() {
    return this.tilesDisplayable;
  }

  public goTo(page: string) {
    this.getIFRS().getSidebar().setMenuItem(page);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts